module.exports = __webpack_public_path__ + "img/Telecom_Recall_3_Set.3720e6fa.png";